/*
 * K-Beauty Real Gems — product page (Phase 5).
 * - Variant option buttons: track current selection per option position, find
 *   matching variant from window.__krgVariants, update price/availability/URL.
 * - Thumbnail click → swap hero image.
 * - Complete the Routine: async fetch the recommendations endpoint into the
 *   upsell slot if it's empty on first paint (e.g., the page was server-rendered
 *   before the recommendations object was populated, which is typical).
 * - Add-to-Bag form submit is handled by krg-cart.js (Phase 3 catches any
 *   /cart/add form, opens the drawer).
 */
(function () {
  'use strict';

  var pdp = document.querySelector('[data-krg-pdp]');
  if (!pdp) return;

  /* ---------- Variant data (server-printed JSON) ---------- */
  var variantsScript = document.querySelector('[data-krg-pdp-variants]');
  var variants = [];
  if (variantsScript) {
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }
  }

  function buildSelection() {
    var sel = {};
    document.querySelectorAll('[data-krg-opt].krg-pdp__opt--sel').forEach(function (b) {
      sel[b.getAttribute('data-option-position')] = b.getAttribute('data-option-value');
    });
    return sel;
  }

  function findVariant(sel) {
    return variants.find(function (v) {
      return (v.options || []).every(function (val, i) {
        return sel[String(i + 1)] === val;
      });
    });
  }

  function fmtMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function applyVariant(variant) {
    if (!variant) return;
    var idEl = document.querySelector('[data-krg-pdp-variant-id]');
    if (idEl) idEl.value = variant.id;
    var priceCur = document.querySelector('[data-krg-pdp-price-current]');
    if (priceCur) priceCur.textContent = fmtMoney(variant.price);
    var priceWas = document.querySelector('[data-krg-pdp-price-was]');
    if (priceWas) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceWas.textContent = fmtMoney(variant.compare_at_price);
        priceWas.hidden = false;
      } else {
        priceWas.textContent = '';
        priceWas.hidden = true;
      }
    }
    var atb = document.querySelector('[data-krg-pdp-atb]');
    if (atb) {
      if (variant.available) {
        atb.removeAttribute('disabled');
        atb.textContent = 'Add to Bag';
      } else {
        atb.setAttribute('disabled', 'true');
        atb.textContent = 'Sold Out';
      }
    }
    // Push selection to URL (?variant=<id>)
    var url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url.toString());

    // Swap hero image if this variant has a featured image. If that image is
    // one of the thumbnails, activate it (keeps the gallery in sync); otherwise
    // just swap the hero source.
    if (variant.featured_image && variant.featured_image.src) {
      var vsrc = variant.featured_image.src;
      var match = krgThumbs().filter(function (t) { return t.getAttribute('data-src') === vsrc; })[0];
      if (match) activateThumb(match);
      else setHeroSrc(vsrc);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-krg-opt]');
    if (!btn) return;
    e.preventDefault();
    var pos = btn.getAttribute('data-option-position');
    document.querySelectorAll('[data-krg-opt][data-option-position="' + pos + '"]').forEach(function (b) {
      b.classList.toggle('krg-pdp__opt--sel', b === btn);
    });
    applyVariant(findVariant(buildSelection()));
  });

  /* ---------- Media gallery (thumbnails + hero arrows) ---------- */
  function krgThumbs() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-krg-thumb]'));
  }
  function setHeroSrc(src) {
    var hero = document.querySelector('[data-krg-pdp-hero] img');
    if (!hero || !src) return;
    // The hero <img> carries a responsive `srcset`; the browser keeps resolving
    // the original image from it and ignores a changed `.src`. Clear srcset +
    // sizes first so the new src actually shows. (This was the swap bug.)
    hero.removeAttribute('srcset');
    hero.removeAttribute('sizes');
    hero.src = src;
  }
  function activateThumb(thumb) {
    if (!thumb) return;
    setHeroSrc(thumb.getAttribute('data-src'));
    krgThumbs().forEach(function (t) {
      t.classList.toggle('krg-pdp__thumb--active', t === thumb);
    });
    // Keep the active thumb in view in the mobile scrollable strip.
    if (thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }
  function stepHero(dir) {
    var thumbs = krgThumbs();
    if (thumbs.length < 2) return;
    var i = thumbs.findIndex(function (t) { return t.classList.contains('krg-pdp__thumb--active'); });
    if (i < 0) i = 0;
    activateThumb(thumbs[(i + dir + thumbs.length) % thumbs.length]); // wrap around
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-krg-thumb]');
    if (thumb) { activateThumb(thumb); return; }
    if (e.target.closest('[data-krg-hero-prev]')) { e.preventDefault(); stepHero(-1); return; }
    if (e.target.closest('[data-krg-hero-next]')) { e.preventDefault(); stepHero(1); return; }
  });

  /* ---------- Complete the Routine async fetch ----------
   * Try complementary first (curated "pairs with"); if none configured,
   * fall back to related (Shopify auto-generates these). Reveal the block
   * only when we actually have items.
   */
  var recsWrap = document.querySelector('[data-krg-pdp-recs]');
  if (recsWrap) {
    var base = recsWrap.getAttribute('data-recs-base');
    var slot = recsWrap.querySelector('[data-krg-pdp-recs-slot]');

    function loadRecs(intent) {
      return fetch(base + '&intent=' + intent)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var inner = tmp.querySelector('[data-krg-pdp-recs-inner]');
          var items = inner ? inner.querySelectorAll('.krg-pdp__up-item').length : 0;
          if (items > 0 && slot) {
            slot.innerHTML = inner.innerHTML;
            recsWrap.hidden = false;
            return true;
          }
          return false;
        })
        .catch(function () { return false; });
    }

    if (base && slot) {
      loadRecs('complementary').then(function (ok) {
        if (!ok) loadRecs('related');
      });
    }
  }
})();

/* ---------- Okendo star rating → reviews scroll ----------
 * Clicking Okendo's star rating should jump to the reviews widget. Okendo's own
 * scroll assumes the window scrolls, but Horizon scrolls `.page-wrapper` on
 * desktop (>=990px), so its math overshoots and lands past the reviews on white
 * space. Intercept the click (capture phase) and scroll to the widget's top
 * ourselves, using the correct scroller.
 */
(function () {
  'use strict';
  var OFFSET = 84; // clear the sticky header
  var STARS_SEL = '.krg-pdp__okendo-stars, [data-oke-star-rating]';

  // Resolve the active scroller + destination scrollTop for the reviews widget.
  // Horizon scrolls `.page-wrapper` on desktop (>=990px) and `window` on mobile.
  function getDest() {
    var target = document.getElementById('okendo-reviews') || document.querySelector('.krg-pdp-okendo');
    if (!target) return null;
    var pw = document.querySelector('.page-wrapper');
    if (pw && window.matchMedia('(min-width: 990px)').matches) {
      return { el: pw, top: Math.max(0, target.getBoundingClientRect().top - pw.getBoundingClientRect().top + pw.scrollTop - OFFSET) };
    }
    return { el: null, top: Math.max(0, target.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - OFFSET) };
  }
  function scrollToReviews() {
    var dest = getDest();
    if (!dest) return;
    // `.page-wrapper` (and the root) carry CSS `scroll-behavior: smooth`, which
    // turns every programmatic scroll into a cancellable animation — and Okendo's
    // focus/scroll keeps cancelling it, so a smooth scroll lands short or not at
    // all. Force an instant, non-cancellable jump by overriding scroll-behavior
    // for the assignment, then restore it.
    var node = dest.el || document.scrollingElement || document.documentElement;
    var prev = node.style.scrollBehavior;
    node.style.scrollBehavior = 'auto';
    if (dest.el) dest.el.scrollTop = dest.top;
    else window.scrollTo(0, dest.top);
    node.style.scrollBehavior = prev;
  }

  // Okendo's star rating is a role="button" (tabindex=0). A plain click both
  // (a) runs Okendo's own scroll — which assumes `window` scrolls and overshoots
  // past the reviews on Horizon — and (b) focuses the button, after which the
  // browser smooth-scrolls it back into view and cancels our scroll. Kill (a) by
  // stopping the click in capture; kill (b) by preventing focus on pointer/mouse
  // down, so our instant scroll runs uncontested.
  document.addEventListener('mousedown', function (e) {
    if (e.target.closest(STARS_SEL)) e.preventDefault();
  }, true);
  document.addEventListener('pointerdown', function (e) {
    if (e.target.closest(STARS_SEL)) e.preventDefault();
  }, true);
  document.addEventListener('click', function (e) {
    if (!e.target.closest(STARS_SEL)) return;
    e.preventDefault();
    e.stopImmediatePropagation(); // suppress Okendo's mis-positioned scroll
    scrollToReviews();
  }, true);
})();
